export const tooltips: { [key: string]: string} = {
    smoker: "A smoker is someone who smokes consistently on a daily basis, regardless of the amount smoked.",
    height: "This should be your height in bare feet or socks.",
    weight: "This should be your weight wearing indoor clothing.",
    waist: `Your waist measurement should be taken at the narrowest part of your torso,
     between your rib cage and belly button. As a guide if you bend to one
     side then the crease formed is your natural waistline.`,
    medical: `Please be completely honest about any conditions you have or have had in the past. 
    If you are unsure, please declare the condition. The provider will assess your declared medical condition(s) 
    later to decide if the income quoted is correct.
    <br><br>
    There is no limit to how far back you should go in your history. For example, if you had cancer as a child, 
    you should declare this even if you have had no recurrence since then.
    <br><br>
    Remember, your medical conditions may impact the annuity income offered by the provider. 
    This is because the providers consider the life expectancy for both lives.`,
    cigarettesPerDay: `This should be the number of manufactured
    cigarettes you smoke or used to smoke on average each day.`,
    cigarsPerDay: "This should be the number of cigars you smoke or used to smoke on average each day.",
    rollingTobaccoPerWeek: `This should be the amount of tobacco you smoke or used to
    smoke on average each week. Please enter a whole number, for example 12 grams.`,
    pipeTobaccoPerWeek: `This should be the amount of tobacco you smoke or used to smoke on average each week.
    Please enter a whole number, for example 12 grams.`,
    alcohol: `As a rough guide: a 175ml glass of wine typically contains 2 units,
    a pint of beer at 4.5% abv typically contains 2.6 units and a 25ml
    measure of a 40% abv spirit typically contains 1 unit.
    If you do not drink weekly, think about how many units you drink per month/year and take a weekly average.
    <br><br>
    Use our alcohol unit calculator to calculate the number of units you drink.`,
};
